/******/ (() => { // webpackBootstrap
/*!*********************************************************!*\
  !*** ./_build/scripts/snippets/layout-product-media.js ***!
  \*********************************************************/
class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.loadSlider();
    this.initMediaToggle();
    
  }

  loadSlider() {
    if (window.theme.Swiper) {
      this.initSlider();
    } else {
      document.addEventListener(
        'theme:inititialised',
        () => {
          this.initSlider();
        },
        { once: true }
      );
    }
  }

  initSlider() {
    if (this._slider) {
      this._slider.destroy(true, true);
      this._slider = null;
    }

    const mediaQuery = window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`);
    const sliderPrevElement = this.querySelector('[data-lpm-slider-prev]');
    const sliderNextElement = this.querySelector('[data-lpm-slider-next]');

    let slider = this._slider = new window.theme.Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 8,
      navigation: {
        prevEl: sliderPrevElement,
        nextEl: sliderNextElement,
      },
      breakpoints: {
        [window.theme.breakpoints.lg]: {
          slidesPerView: 'auto',
        },
      },
    });

    const handler = (e) => {
      if (e.matches) {
        slider.disable();
      } else {
        slider.enable();
        slider.updateSize()
      }
    };

    mediaQuery.addEventListener('change', handler);
    handler(mediaQuery);
  }

  initMediaToggle() {
    const mediaContainer = this;
    const mediaToggle = this.querySelector('[data-lpm-slider-toggle]');

    if(mediaToggle){
      mediaToggle.addEventListener('click', function() {
        mediaContainer.classList.toggle('media-all-visible');
        this.classList.toggle('is-active');
      });
    }
  }
}

customElements.define('product-media', ProductMedia);

/******/ })()
;